<template>
  <span
    class="material-icons-outlined"
    :class="sizeClass"
    aria-hidden="true"
  >file_download</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const SIZE_CLASSES: Record<string, string> = {
  sm: 'text-sm w-3.5 h-3.5',
  base: 'text-base w-4 h-4',
  lg: 'text-lg w-[18px] h-[18px]',
  xl: 'text-xl w-5 h-5',
}

const props = defineProps({
  size: {
    type: String,
    required: false,
    default: 'base',
  }
})

const sizeClass = computed(() => SIZE_CLASSES[props.size] ?? SIZE_CLASSES.base)
</script>
